// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".deleteWarningContent___Xl6sz{padding:24px 0;line-height:24px}.sectionOne___wovqg{padding-bottom:24px}.modalContainer___zw1I4{width:464px}\n", "",{"version":3,"sources":["webpack://./src/routes/Parameters/components/DeleteParamModal/DeleteParamModal.css"],"names":[],"mappings":"AAAA,8BAAA,cAAA,CAEI,gBAAA,CAGJ,oBACI,mBAAA,CAGJ,wBACI,WAAA","sourcesContent":[".deleteWarningContent {\n    padding: 24px 0;\n    line-height: 24px;\n}\n\n.sectionOne {\n    padding-bottom: 24px;\n}\n\n.modalContainer {\n    width: 464px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteWarningContent": "deleteWarningContent___Xl6sz",
	"sectionOne": "sectionOne___wovqg",
	"modalContainer": "modalContainer___zw1I4"
};
export default ___CSS_LOADER_EXPORT___;
